const reportWebVitals = () => undefined;

export default reportWebVitals;
